import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs";
import { BiFilterAlt } from "react-icons/bi";
import { FaCircleCheck } from "react-icons/fa6";
import { MdCancel } from "react-icons/md";
import Popup from "../../popups/Popup/Popup";
import { useDispatch, useSelector } from "react-redux";
import {
  getUploadedUGCContentList,
  getUploadedUGCContentListReset,
  getUploadedUGCContentListResetAll,
} from "../../../store/campaignStore/actions/CreateCampaignActions/getUploadedUGCContentListActions";
import { getBrandCampaign } from "../../../store/campaignStore/actions/CreateCampaignActions/getBrandCampaignActions";
import moment from "moment/moment";
import { streamVideo } from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/streamVideoActions";
import {
  markApprovedRejectedContent,
  markApprovedRejectedContentReset,
} from "../../../store/campaignStore/actions/CreateCampaignActions/markApprovedRejectedContentActions";
import Footer from "../../common/Footer/Footer";
import DataTable from "react-data-table-component";
import { useToast } from "../../../hooks/useToast";
import BrandFilterBar from "../../common/BrandFilterBar/BrandFilterBar";

const getStatusStyle = (status) => {
  switch (status) {
    case "APPROVED":
      return "bg-[#00B69B] text-[#FFFFFF]";
    case "PENDING_APPROVAL":
      return "bg-[#FCBE2D] text-[#FFFFFF]";
    case "REJECTED":
      return "bg-[#FD5454] text-[#FFFFFF]";
    default:
      return "bg-[#FCBE2D] text-[#FFFFFF]";
  }
};

const ContentCard = ({ row, onApprove, onReject, onViewContent, getUserInfoReducerData }) => (
  <div className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300">
    <div className="flex flex-col space-y-3">
      {/* Influencer Name - Larger Font */}
      <div>
        <span className="text-[1.6rem] font-medium">{row.influencerName}</span>
      </div>

      {/* Upload Date */}
      <div className="flex items-center">
        <span className="text-[1.4rem] font-bold w-32">Upload Date:</span>
        <span className="text-[1.4rem]">
          {moment.utc(row.uploadedAt.split("+")[0]).local().format("DD-MM-YYYY hh:mm") || "N/A"}
        </span>
      </div>

      {/* Channel Name */}
      <div className="flex items-center">
        <span className="text-[1.4rem] font-bold w-32">Channel:</span>
        <span className="text-[1.4rem]">{row.platform}</span>
      </div>

      {/* Platform */}
      <div className="flex items-center">
        <span className="text-[1.4rem] font-bold w-32">Platform:</span>
        <span className="text-[1.4rem]">{row.platform}</span>
      </div>

      {/* Status */}
      <div className="flex items-center">
        <span className="text-[1.4rem] font-bold w-32">Status:</span>
        <span className={`text-[1.4rem] px-2 py-1 rounded-full ${getStatusStyle(row.campaignStatus)}`}>
          {row.status || "N/A"}
        </span>
      </div>

      {/* Action Buttons */}
      <div className="mt-2 flex flex-col space-y-2">
        <button
          className="bg-[#FF0505CC] text-white text-[1.4rem] px-4 py-2 rounded-lg w-full"
          onClick={() => onViewContent(row)}
        >
          View Content
        </button>
        <div className="flex space-x-2">
          {getUserInfoReducerData?.agencyRoleName !== "Viewer" && (
            <>
              <button
                className="bg-[#0D9B50] text-white text-[1.4rem] px-4 py-2 rounded-lg flex-1"
                onClick={() => onApprove(row.contentId)}
              >
                Approve
              </button>
              <button
                className="bg-[#FF0303] text-white text-[1.4rem] px-4 py-2 rounded-lg flex-1"
                onClick={() => onReject(row.contentId)}
              >
                Reject
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  </div>
);

const BrandCampaignList = () => {
  const dispatch = useDispatch();
  const Toast = useToast();

  const getBrandCampaignReducerData = useSelector(
    (state) => state.getBrandCampaignReducer.data
  );
  const getBrandCampaignReducerStatus = useSelector(
    (state) => state.getBrandCampaignReducer.status
  );
  const getUploadedUGCContentListReducerData = useSelector(
    (state) => state.getUploadedUGCContentListReducer?.data
  );
  const getUploadedUGCContentListReducerStatus = useSelector(
    (state) => state.getUploadedUGCContentListReducer?.status
  );

  const markApprovedRejectedContentReducerData = useSelector(
    (state) => state.markApprovedRejectedContentReducer?.data
  );

  const markApprovedRejectedContentReducerStatus = useSelector(
    (state) => state.markApprovedRejectedContentReducer?.status
  );

  const getUserInfoReducerData = useSelector(
    (state) => state.getUserInfoReducer?.data
  );

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [campaignData, setCampaignData] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState();
  const [contentId, setContentId] = useState();
  const [selectedcontent, setselectedContent] = useState();
  const [selectedstatus, setselectedstatus] = useState();
  const [rejectionReason, setRejectionReason] = useState("");
  const [getUploadedUGCContentListData, setgetUploadedUGCContentListData] =
    useState([]);

  const [filteredCampaigns, setFilteredCampaigns] = useState();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    dispatch(
      getUploadedUGCContentList({
        campaignId: selectedCampaign,
      })
    );
  }, [selectedCampaign]);

  useEffect(() => {
    if (getUploadedUGCContentListReducerStatus == 200) {
      setFilteredCampaigns(getUploadedUGCContentListReducerData);
      dispatch(getUploadedUGCContentListReset());
    } else if (getUploadedUGCContentListReducerStatus == 302) {
      setFilteredCampaigns(getUploadedUGCContentListReducerData);
      dispatch(getUploadedUGCContentListReset());
    } else if (getUploadedUGCContentListReducerStatus) {
      dispatch(getUploadedUGCContentListReset());
    }
  }, [getUploadedUGCContentListReducerStatus]);

  useEffect(() => {
    dispatch(getBrandCampaign({ brandId: "" }));
  }, []);

  const breadcrumbData = [
    { label: "Home", href: "/" },
    { label: "My Campaigns", href: getUserInfoReducerData?.userType === "AGENCY" ? "/agency/campaigns" : "/brand/campaigns" },
    { label: "Campaign List", href: "#" },
  ];

  // Check if the screen is mobile size
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768); // 768px is typical tablet breakpoint
    };

    // Set initial value
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);

    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const columns = [
    {
      name: "Influencer",
      selector: (row) => row.influencerName,
      sortable: true,
      style: {
        width: "10rem", // Set a smaller width for this column
      },
    },
    {
      name: "Upload Date",
      selector: (row) =>
        moment
          .utc(row.uploadedAt.split("+")[0])
          .local()
          .format("DD-MM-YYYY hh:mm") || "N/A",
      sortable: true,
      style: {
        width: "10rem", // Adjust the width as needed
      },
    },
    {
      name: "Channel Name",
      selector: (row) => row.platform,
      style: {
        width: "10rem", // Set a smaller width for this column
      },
    },
    {
      name: "Platform",
      selector: (row) => row.platform,
      sortable: true,
      style: {
        width: "10rem",
      },
    },
    {
      name: "Status",
      selector: (row) => (
        <span
          className={`w-full max-w-[17rem] min-h-[2.7rem] text-sm px-3 py-2 rounded-full 
                flex justify-center items-center break-words ${getStatusStyle(
            row.campaignStatus
          )}`}
        >
          {row.status || "N/A"}
        </span>
      ),
      style: {
        width: "10rem",
      },
    },
    {
      name: "Content",
      selector: (row) => (
        <button
          className="bg-[#FF0505CC] text-white text-center rounded-[1rem] py-[0.5rem] px-[2.5rem]"
          onClick={() => {
            dispatch(
              streamVideo(
                { s3ContentPath: row.contentPath },
                (status, response, message) => {
                  if (status === 200) {
                    window.open(response, "_blank", "rel=noopener noreferrer");
                  }
                }
              )
            );
          }}
        >
          View
        </button>
      ),
      style: {
        width: "10rem",
      },
    },
    getUserInfoReducerData?.agencyRoleName !== "Viewer" &&
    {
      name: "Action",
      selector: (row) => (
        <div className="flex flex-col md:flex-row gap-2 w-full">
          <button
            className="bg-[#0D9B50] text-white text-center rounded-[1rem] py-[0.5rem] px-[1rem] whitespace-nowrap"
            onClick={() => handleApprove(row.contentId)}
          >
            Approve
          </button>
          <button
            className="bg-[#FF0303] text-white text-center rounded-[1rem] py-[0.5rem] px-[1rem] whitespace-nowrap"
            onClick={() => handleReject(row.contentId)}
          >
            Reject
          </button>
        </div>
      ),
      style: {
        width: "12rem", // Increased from 10rem
        minWidth: '130px',
        '@media (max-width: 768px)': {
          minWidth: '110px', // Different min-width for mobile
        } // Increased from 120px
      },
    },
  ];

  const customTableStyles = {
    table: {
      style: {
        position: "relative",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#F1F4F9",
        minHeight: "52px",
        fontWeight: 700,
        borderRadius: "0.4rem",
        borderBottom: "none",
        // position: 'fixed',
        top: 0,
      },
      denseStyle: {
        minHeight: "32px",
      },
    },
    rows: {
      style: {
        fontSize: "1.4rem", // Increased text size for rows
        fontWeight: 600,
        color: "#202224",
        borderBottom: "1px solid #EDEFF1",
        minHeight: "70px",
      },
      denseStyle: {
        minHeight: "40px",
      },
    },
    headCells: {
      style: {
        padding: "1rem",
        fontSize: "1.6rem",
        textAlign: "left",
      },
    },
    cells: {
      style: {
        padding: "1.5rem",
      },
    },
  };

  const handleApprove = (contentId, status) => {
    setselectedContent(contentId);
    // setselectedstatus(status);
    setPopupType("approve");
    setPopupOpen(true);
  };

  const handleReject = (contentId, status) => {
    setselectedContent(contentId);
    // setselectedstatus(status);
    setRejectionReason("");
    setPopupType("reject");
    setPopupOpen(true);
  };

  const handleRejectionReasonChange = (event, ugcRejectReason) => {
    setRejectionReason(event.target.value);
  };

  const handleFilter = (brandId) => {
    console.log("brandId", brandId);
    dispatch(getBrandCampaign({ brandId: brandId ? brandId : "" }));
  };

  const handleReset = () => {
    console.log("reset");
    dispatch(getBrandCampaign({ brandId: "" }));
  };

  const handleViewContent = (row) => {
    dispatch(
      streamVideo(
        { s3ContentPath: row.contentPath },
        (status, response, message) => {
          if (status === 200) {
            window.open(response, "_blank", "rel=noopener noreferrer");
          }
        }
      )
    );
  };

  return (
    <div className="w-full h-full flex flex-col overflow-auto bg-[#F2F3F7]">
      <Breadcrumbs breadcrumbs={breadcrumbData} />

      <h1 className="text-[2.4rem] text-[#534D4D] inter-font font-[700] px-[4rem] py-[1.5rem]">
        Campaign List
      </h1>
      {getUserInfoReducerData?.userType === "AGENCY" &&
        <div className="px-[4rem] my-2">
          <BrandFilterBar
            onFilter={handleFilter}
            onReset={handleReset}
          />
        </div>
      }
      <div className="px-[4rem] mb-[1.5rem]  pb-[1.5rem] flex justify-between items-center">
        <select
          className="w-full md:w-[40%] px-[1.5rem] py-[1rem] text-[#677489] text-[1.6rem] inter-font font-[400] border border-[#E1E1E1] rounded-[0.5rem] bg-white shadow-sm"
          onChange={(e) => {
            console.log("e.target", e.target.value);
            setSelectedCampaign(e.target.value);
          }}
        >
          <option value="" selected disabled>
            Select Campaign Option
          </option>
          {getBrandCampaignReducerData?.length > 0 ? (
            getBrandCampaignReducerData
              ?.filter((item) => {
                return (
                  item.campaignType == "UGC" &&
                  item.campaignStatus == "APPROVED" &&
                  item.isBrandApprovalRequired == true
                );
              })
              .map((items) => {
                return <option value={items.campaignId}>{items.name}</option>;
              })
          ) : (
            <div className="text-[1.4rem] text-center">
              No campaign available
            </div>
          )}
        </select>
        {/* <button className="px-[1rem] py-[0.5rem] bg-white border border-[#E1E1E1] text-[2.4rem] text-[#272829] rounded-[0.5rem] shadow-sm">
                    <BiFilterAlt />
                </button> */}
      </div>

      {/* Content List Table */}
      <div className="px-[4rem] w-full">
        <div className="w-full h-full flex flex-col rounded-[2.6rem] bg-[#ffffff]">
          <div className="sticky top-0 z-10 bg-[#ffffff] p-[2.8rem]">
            <h2 className="text-[2.4rem] inter-font font-[700]">
              Content List
            </h2>
          </div>
          <div className="w-full max-h-[50rem] overflow-y-auto no-scrollbar px-[2.4rem] pb-[2.4rem]">
            {Array.isArray(filteredCampaigns) && filteredCampaigns.length > 0 ? (
              isMobile ? (
                // Mobile view - Cards
                <div className="flex flex-col space-y-4">
                  {filteredCampaigns.map((row, index) => (
                    <ContentCard
                      key={index}
                      row={row}
                      onApprove={handleApprove}
                      onReject={handleReject}
                      onViewContent={handleViewContent}
                      getUserInfoReducerData={getUserInfoReducerData}
                    />
                  ))}
                </div>
              ) : (
                // Desktop view - Table
                <DataTable
                  columns={columns}
                  data={filteredCampaigns}
                  customStyles={customTableStyles}
                  pagination
                  highlightOnHover
                  responsive
                />
              )
            ) : (
              <div className="text-4xl leading-[70px] text-gray-500 text-center mt-4">
                There are no records to display.
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Popup */}
      {popupType === "approve" && (
        <Popup
          isOpen={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          title="Approve"
          canDismiss
          icon={
            <FaCircleCheck color="#0D9B50" size={110} className="my-[5rem]" />
          }
          content={
            <p className="text-[1.6rem] w-full mx-auto text-center">
              Are you sure you want to approve this content?
            </p>
          }
          size="sm"
          primaryButton={{
            text: "Yes",
            onClick: () => {
              dispatch(
                markApprovedRejectedContent(
                  { contentId: selectedcontent, status: "UGC_APPROVED" },
                  (status, response, message) => {
                    if (status == 200) {
                      dispatch(
                        getUploadedUGCContentList(
                          {
                            campaignId: contentId,
                          },
                          (status, response, message) => {
                            if (status === 200) {
                              setgetUploadedUGCContentListData(response);
                              dispatch(getUploadedUGCContentListReset());
                            } else if (status) {
                              dispatch(getUploadedUGCContentListReset());
                            }
                          }
                        )
                      );
                      setPopupOpen(false);
                    } else if (status === 305) {
                      setPopupOpen(false);
                      // setPopupForTokenExpireOpen(true)
                    } else if (status) {
                      setPopupOpen(false);
                    }
                  }
                )
              );
            },
          }}
          secondaryButton={{
            text: "No",
            onClick: () => setPopupOpen(false),
          }}
        />
      )}

      {popupType === "reject" && (
        <Popup
          isOpen={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          title="Reject"
          canDismiss
          icon={<MdCancel color="#FF0505" size={110} className="mt-[5rem]" />}
          content={
            <>
              <p className="text-[1.6rem] w-full mx-auto text-center my-[2rem]">
                Please provide a reason for rejection.
              </p>
              <form className="space-y-4">
                <div>
                  <input
                    id="description"
                    value={rejectionReason}
                    onChange={handleRejectionReasonChange}
                    placeholder="Please enter a reason"
                    className="w-full bg-[#FFFFFF] h-20 border text-[1.6rem] border-gray-300 rounded-2xl px-4 py-2 focus:outline-none"
                  />
                </div>
              </form>
            </>
          }
          size="sm"
          primaryButton={{
            text: "Reject",
            onClick: () => {
              if (!rejectionReason.trim()) {
                Toast("Please enter a reason for rejection.", "error");
                return;
              }
              dispatch(
                markApprovedRejectedContent(
                  {
                    contentId: selectedcontent,
                    status: "UGC_REJECTED",
                    ugcRejectReason: rejectionReason,
                  },
                  (status, response, message) => {
                    if (status == 200) {
                      dispatch(
                        getUploadedUGCContentList(
                          {
                            campaignId: contentId,
                          },
                          (status, response, message) => {
                            if (status === 200) {
                              setgetUploadedUGCContentListData(response);
                              dispatch(getUploadedUGCContentListReset());
                            } else if (status) {
                              dispatch(getUploadedUGCContentListReset());
                            }
                          }
                        )
                      );
                      setPopupOpen(false);
                    } else if (status === 305) {
                      setPopupOpen(false);
                      // setPopupForTokenExpireOpen(true)
                    } else if (status) {
                      setPopupOpen(false);
                    }
                  }
                )
              );
            },
          }}
          secondaryButton={{
            text: "Cancel",
            onClick: () => setPopupOpen(false),
          }}
        />
      )}

      <Footer />
    </div>
  );
};

export default BrandCampaignList;
